
















































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import CommonVue from '../../models/commonVue';
import Draggable from 'vuedraggable';
import { BusEvent } from '@/models/bus';
import Module from '@/api/module';
import Submodule from '../../api/submodule';
import Lesson from '../../api/lesson';
import ApiList from '../../api/list';
import EditIcon from '@/components/icons/EditIcon.vue';
import LockManager from '@/models/lock';

@Component({
  components: {
    draggable: Draggable,
    'edit-icon': EditIcon
  }
})
export default class ListLesson extends CommonVue {
  @Prop() public module!: Module;
  @Prop({ type: String, default: Module.SLUG }) public parent: string;

  public submodules: ApiList<Submodule> = null;
  public lessons: ApiList<Lesson> = null;

  public submoduleDragOptions: object = {
    group: 'submodule',
    ghostClass: 'ghost'
  };
  public lessonDragOptions: object = {
    group: 'lesson',
    ghostClass: 'ghost'
  };
  public draggedElement: Lesson | Submodule = null;
  public moving: boolean = false;

  public async beforeMount() {
    this.busy = true;
    await this.loadSubModules();
    await this.loadLessons();
    this.busy = false;
  }

  @Watch('module')
  public async loadSubModules() {
    if (this.module) {
      try {
        this.submodules = await Submodule.getSubmodulesOfModule(this.module.id);
      } catch (e) {
        this.$bus.$emit(BusEvent.ERROR, 'Could not load submodules', e);
        this.error = true;
      }
    }
  }

  @Watch('module')
  public async loadLessons() {
    if (this.module) {
      try {
        this.lessons = await Lesson.getLessonsOfModule(this.module.id);
      } catch (e) {
        this.$bus.$emit(BusEvent.ERROR, 'Could not load lessons', e);
        this.error = true;
      }
    }
  }

  public async lessonMoving({ draggedContext }) {
    // when it starts moving
    if (!this.moving) {
      try {
        this.moving = true;
        if (this.lockManager && this.lockManager.isLocked) {
          await this.lockManager.releaseLock();
          this.lockManager = null;
        }
        this.lockManager = new LockManager(
          this.LESSON_SLUG,
          draggedContext.element.id
        );
        this.draggedElement = draggedContext.element;
        await this.tryToLock();
      } catch (e) {
        this.moving = false;
        this.error = true;
        return false;
      }
    }
  }

  public async submoduleMoving({ draggedContext }) {
    // when it starts moving
    if (!this.moving) {
      try {
        this.moving = true;
        if (this.lockManager && this.lockManager.isLocked) {
          await this.lockManager.releaseLock();
          this.lockManager = null;
        }
        this.lockManager = new LockManager(
          this.SUBMODULE_SLUG,
          draggedContext.element.id
        );
        this.draggedElement = draggedContext.element;
        await this.tryToLock();
      } catch (e) {
        this.moving = false;
        this.error = true;
        return false;
      }
    }
  }

  public async lessonDropped(e) {
    await this.tryToLock();
    if (this.draggedElement) {
      const parentChanged = (this.draggedElement as Lesson).parent_submodule;
      let wasParentChanged = false;
      this.draggedElement.order = e.newIndex;
      const submodule = e.to.getAttribute('submodule');
      if (submodule && submodule !== 'null') {
        (this.draggedElement as Lesson).parent_submodule = parseInt(
          submodule,
          10
        );
        wasParentChanged = parentChanged !== parseInt(submodule, 10); // assign true/false if both items are different
      } else if (submodule === 'null') {
        (this.draggedElement as Lesson).parent_submodule = null;
        wasParentChanged =
          parentChanged !== null && parentChanged !== undefined;
      }

      // TODO switching lessons between submodules requires this for view to update. But it is too slow
      // if possible remove loadLessons() and parentChanged variable
      if (wasParentChanged) {
        this.busy = true;
        await this.draggedElement.save();
        await this.loadLessons();
        this.busy = false;
      } else {
        await this.draggedElement.save();
      }
    }
    this.draggedElement = null;
    this.moving = false;
    if (this.lockManager && this.lockManager.isLocked) {
      await this.lockManager.releaseLock();
      this.lockManager = null;
    }
  }

  public async submoduleDropped(e) {
    if (this.draggedElement) {
      this.draggedElement.order = e.newIndex;
      await this.draggedElement.save();
    }
    this.draggedElement = null;
    this.moving = false;

    if (this.lockManager && this.lockManager.isLocked) {
      await this.lockManager.releaseLock();
      this.lockManager = null;
    }
  }
  
  public editLesson(lessonId: number, e) {
    e.stopPropagation();
    this.$router.push(
      `/${this.parent}/${this.module.id}/${this.LESSON_SLUG}/${lessonId}`
    );
  }
}
